const productTags = {
  DEFAULT_PRODUCT_TAG_COLOR: "#000000",
};

export default productTags;
